'use client'

import { useFormState, useFormStatus } from 'react-dom'
import { login } from '@/app/actions/auth'

function SubmitButton() {
  const { pending } = useFormStatus()
  return (
    <button
      type="submit"
      disabled={pending}
      className="w-full py-2.5 rounded-lg text-white font-semibold text-sm transition-opacity disabled:opacity-60 cursor-pointer"
      style={{ background: 'linear-gradient(135deg,#F0997B,#D85A30)' }}
    >
      {pending ? '로그인 중...' : '로그인'}
    </button>
  )
}

export default function LoginPage() {
  const [state, formAction] = useFormState(login, null)

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#FFF8F5]">
      <div className="w-full max-w-sm px-4">
        {/* 로고 */}
        <div className="text-center mb-8">
          <div
            className="inline-flex items-center justify-center w-16 h-16 rounded-2xl text-white text-2xl font-bold mb-3"
            style={{ background: 'linear-gradient(135deg,#F0997B,#D85A30)' }}
          >
            B
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Bricks LMS</h1>
          <p className="text-sm text-gray-500 mt-1">학생 로그인</p>
        </div>

        {/* 폼 */}
        <form action={formAction} className="space-y-4">
          <div className="space-y-1.5">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              이메일
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              placeholder="student@example.com"
              className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#D85A30] focus:border-transparent bg-white"
            />
          </div>

          <div className="space-y-1.5">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              비밀번호
            </label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              placeholder="••••••••"
              className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#D85A30] focus:border-transparent bg-white"
            />
          </div>

          {state?.error && (
            <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2">
              {state.error === 'Invalid login credentials'
                ? '이메일 또는 비밀번호가 올바르지 않습니다.'
                : state.error}
            </p>
          )}

          <SubmitButton />
        </form>
      </div>
    </main>
  )
}
